export default __webpack_public_path__ + "video/2673bd039efe5a1845607f44b11ed228.mp4";